export const campaignStatuses = ['draft', 'configured', 'active', 'paused', 'completed', 'archived'] as const

export type CampaignStatus = (typeof campaignStatuses)[number]

const campaignTransitions: Readonly<Record<CampaignStatus, readonly CampaignStatus[]>> = {
  draft: ['configured'],
  configured: ['draft', 'active'],
  active: ['paused', 'completed'],
  paused: ['active', 'completed'],
  completed: ['archived'],
  archived: [],
}

export function isCampaignStatus(value: unknown): value is CampaignStatus {
  return typeof value === 'string' && campaignStatuses.includes(value as CampaignStatus)
}

export function getAllowedCampaignTransitions(status: CampaignStatus): readonly CampaignStatus[] {
  return campaignTransitions[status]
}

export function canTransitionCampaign(from: CampaignStatus, to: CampaignStatus): boolean {
  return campaignTransitions[from].includes(to)
}

export function parseCampaignStatus(value: unknown): CampaignStatus {
  if (!isCampaignStatus(value)) throw new Error('INVALID_CAMPAIGN_STATUS')
  return value
}
